<!--
 * @Description: 属性列表
-->
<template>
  <div>
    <el-tabs
      v-model="activeTabName"
      v-if="attributeTableProps.activeTab === '2'"
      @tab-click="activeTabChange"
    >
      <el-tab-pane
        v-for="(item, index) in tabPaneList"
        :key="index"
        :label="item"
        :name="index + ''"
      ></el-tab-pane>
    </el-tabs>
    <el-table
      :data="attributeTableProps.activeTab === '1' ? attributeList : classGroupList"
      v-loading="tableLoading"
      :highlight-current-row="true"
      :header-cell-style="{ textAlign: 'center' }"
      :cell-style="{ textAlign: 'center' }"
      height="328"
      stripe
      border
    >
      <el-table-column type="index" width="65" :label="$t('seqNo')" prop="seqNo"></el-table-column>
      <el-table-column :label="$t('attributeCode')" prop="code"> </el-table-column>
      <el-table-column prop="name" :label="$t('attributeName')">
        <template slot-scope="scoped">
          <div>
            <span v-if="scoped.row.isNullable" style="color: red">*</span>
            {{ scoped.row.name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('attributeValue')">
        <template slot-scope="scope">
          <div v-if="scope.row.isOperate">
            <span @click="operateColumn(scope.row)" class="cur-pointer underline">
              {{ scope.row.value }}
            </span>
            <el-tooltip
              :content="$t('uploadFile')"
              v-if="showUploadBtn(scope.row) && tagListId"
              class="ml-10px"
            >
              <el-button
                class="iconfont icon-line-upload"
                size="mini"
                @click="uploadFiles(scope.row, scope.row.code)"
              ></el-button>
            </el-tooltip>
            <el-tooltip
              :content="$t('查看文件')"
              v-if="showViewBtn(scope.row) && tagListId"
              class="ml-10px"
            >
              <el-button
                class="iconfont icon-line-show"
                type="primary"
                size="mini"
                @click="viewFile(scope.row)"
              ></el-button>
            </el-tooltip>
            <el-tooltip
              :content="$t('downloadFile')"
              v-if="showDownloadBtn(scope.row) && tagListId"
              class="ml-10px"
            >
              <el-button
                class="iconfont icon-line-download"
                size="mini"
                @click="downloadFile(scope.row)"
              ></el-button>
            </el-tooltip>
            <el-tooltip
              :content="$t('deleteFile')"
              v-if="showDeleteBtn(scope.row) && tagListId"
              class="ml-10px"
            >
              <el-button
                class="iconfont icon-line-delete"
                type="danger"
                size="mini"
                @click="deleteFile(scope.row, scope.row.code)"
              ></el-button>
            </el-tooltip>
          </div>
          <!-- 布尔类型 start-->
          <el-select
            v-else-if="scope.row.valueType === 4"
            class="w-full"
            v-model="scope.row.value"
            clearable
            filterable
            :placeholder="`${$t('pleaseSelect')}`"
            @change="change"
            :disabled="attributeTableProps.type === 'read'"
          >
            <el-option :label="$t('yes')" value="是"> </el-option>
            <el-option :label="$t('no')" value="否"> </el-option>
          </el-select>
          <!-- 布尔类型 end-->
          <!-- Enum类型(单选) / 枚举-多选类型（多选）  start-->
          <el-select
            v-else-if="_.includes([5, 7], scope.row.valueType)"
            class="w-full"
            v-model="scope.row.value"
            clearable
            :multiple="scope.row.valueType === 7 ? true : false"
            filterable
            :placeholder="`${$t('pleaseSelect')}`"
            @focus="focus(scope.row)"
            :disabled="attributeTableProps.type === 'read' || scope.row.disabled"
          >
            <el-option
              :label="item.name"
              :value="item.value"
              v-for="(item, index) in scope.row.referenceDataList"
              :key="index"
            >
            </el-option>
          </el-select>
          <!-- Enum类型 end-->
          <!-- 扩展属性下拉 start-->
          <el-select
            v-else-if="scope.row.isExtend"
            class="w-full"
            v-model="scope.row.tempValue"
            :placeholder="$t('pleaseSelect')"
            @focus="focus(scope.row)"
            @change="change(scope.row)"
            :disabled="attributeTableProps.type === 'read' || scope.row.disabled"
            multiple
            filterable
            clearable
          >
            <el-option
              v-for="(item, index) in scope.row.extendList"
              :label="item.extendClassName"
              :value="item.extendClassCode"
              :key="index"
            >
            </el-option>
          </el-select>
          <!-- 扩展属性 end -->
          <el-input
            v-else-if="!scope.row.ruleExpression && scope.row.refrenceAttributeId"
            v-model="scope.row.displayReferenceAttributeCode"
            :placeholder="`${$t('pleaseSelect')}`"
            class="w-full can-not-input"
            :disabled="scope.row.disabled || attributeTableProps.type === 'read'"
            @clear="clearReference(scope.$index)"
            :maxlength="scope.row.length"
            clearable
          >
            <el-button
              slot="append"
              icon="iconfont icon-line-seach"
              @click="searchReference(scope.row, scope.$index)"
              :disabled="scope.row.disabled || attributeTableProps.type === 'read'"
            ></el-button>
          </el-input>
          <el-input
            v-else-if="
              !scope.row.ruleExpression &&
                !scope.row.refrenceAttributeId &&
                scope.row.columnName === 'approve_status'
            "
            v-model="scope.row.value"
            :maxlength="scope.row.length"
            clearable
            disabled
          >
            <template slot="append" v-if="scope.row.unit">
              <div>{{ scope.row.unit }}</div>
            </template>
          </el-input>
          <el-input
            v-else-if="scope.row.referenceClassAttributeId"
            v-model="scope.row.displayReferenceAttributeCode"
            :placeholder="`${$t('pleaseSelect')}`"
            @clear="clearReference(scope.$index)"
            class="w-full can-not-input"
            :disabled="scope.row.disabled || attributeTableProps.type === 'read'"
            clearable
          >
            <el-button
              slot="append"
              icon="iconfont icon-line-seach"
              @click="searchReference(scope.row, scope.$index)"
              :disabled="scope.row.disabled || attributeTableProps.type === 'read'"
            ></el-button>
          </el-input>
          <el-input
            v-model="scope.row.value"
            class="w-full"
            v-else-if="
              !scope.row.ruleExpression &&
                !scope.row.refrenceAttributeId &&
                !scope.row.referenceClassAttributeId &&
                (scope.row.valueType === 1 || scope.row.valueType === 10)
            "
            :disabled="scope.row.disabled || attributeTableProps.type === 'read'"
            :maxlength="scope.row.length"
            clearable
          >
            <template slot="append" v-if="scope.row.unit">
              <div>{{ scope.row.unit }}</div>
            </template>
          </el-input>
          <el-input-number
            v-else-if="
              !scope.row.ruleExpression &&
                !scope.row.refrenceAttributeId &&
                (scope.row.valueType === 2 || scope.row.valueType === 3)
            "
            v-model="scope.row.value"
            :controls="false"
            class="w-full"
            :disabled="scope.row.disabled || attributeTableProps.type === 'read'"
            :data-unit="scope.row.unit"
            :class="scope.row.unit ? 'append_unit' : ''"
          >
          </el-input-number>
          <el-time-picker
            v-else-if="
              !scope.row.ruleExpression &&
                !scope.row.refrenceAttributeId &&
                scope.row.valueType === 9
            "
            v-model="scope.row.value"
            class="!w-full"
            :picker-options="{
              selectableRange: '00:00:00 - 23:59:59',
            }"
            @change="change(scope.row)"
            value-format="HH:mm:ss"
            :placeholder="`${$t('selectTime')}`"
            :disabled="scope.row.disabled || attributeTableProps.type === 'read'"
          ></el-time-picker>
          <el-date-picker
            v-else-if="
              !scope.row.ruleExpression &&
                !scope.row.refrenceAttributeId &&
                scope.row.valueType === 8
            "
            v-model="scope.row.value"
            class="!w-full"
            value-format="yyyy-MM-dd"
            type="date"
            @change="change(scope.row)"
            :placeholder="`${$t('selectDate')}`"
            :disabled="scope.row.disabled || attributeTableProps.type === 'read'"
          ></el-date-picker>
          <el-date-picker
            v-else-if="
              !scope.row.ruleExpression &&
                !scope.row.refrenceAttributeId &&
                scope.row.valueType === 6
            "
            v-model="scope.row.value"
            class="!w-full"
            type="datetime"
            @change="change(scope.row)"
            value-format="yyyy-MM-dd HH:mm:ss"
            :placeholder="`${$t('selectTime')}`"
            :disabled="scope.row.disabled || attributeTableProps.type === 'read'"
          ></el-date-picker>
          <!-- 上传附件 -->
          <div v-else-if="scope.row.valueType === 13">
            <span class="mr-10px">{{
              scope.row.files && scope.row.files.map((it) => it.file).join(',')
            }}</span>
            <el-button
              v-if="!scope.row.disabled && attributeTableProps.type !== 'read'"
              type="primary"
              size="mini"
              @click="uploadAttachments(scope.row)"
              >上传</el-button
            >
          </div>
          <span v-else>{{ scope.row.value }}</span>
        </template>
      </el-table-column>
    </el-table>

    <!-- 绑定引用属性 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('引用属性')"
      :visible.sync="isShowRefrenceAttribute"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      width="40%"
      v-dialogDrag
    >
      <refrenceAttributeSearch
        v-if="isShowRefrenceAttribute"
        :standardId="this.attributeTableProps.standardId"
        :detail="detail"
        :referenceInfo="referenceInfo"
        :single="true"
        :classId="attributeTableProps.classId"
        @selectReferenceClassAttributeId="selectReferenceClassAttributeId"
      />
    </el-dialog>

    <!-- 上传图片 -->
    <el-dialog
      :width="uploadFileTitle === $t('upload') ? '530px' : '1200px'"
      :top="isFullScreen ? '0' : '15vh'"
      id="viewDialog"
      :title="uploadFileTitle"
      :visible.sync="uploadFileVisible"
      v-dialogDrag
    >
      <i
        @click="fullScreen()"
        v-show="uploadFileTitle !== $t('upload')"
        v-if="!isFullScreen"
        class="iconfont icon-line-fullscreen cur-pointer position-absolute"
      ></i>
      <i
        v-show="uploadFileTitle !== $t('upload')"
        @click="exitFullScreen()"
        v-else
        class="iconfont icon-line-fullscreen cur-pointer position-absolute"
      ></i>
      <el-upload
        v-loading="uploadLoading"
        v-if="uploadFileTitle === $t('upload')"
        ref="upload"
        drag
        action="https://xx.yy.zz"
        :show-file-list="false"
        :before-upload="getFileContent"
        :http-request="uploadExcel"
        :multiple="false"
      >
        <i style="font-size: 67px" class="el-icon-upload"></i>
        <div class="el-upload__text">
          {{ $t('onlyOne') }}
          <em>{{ $t('clickUpload') }}</em>
        </div>
      </el-upload>
      <div style="height: 520px" id="fileView" v-else v-loading="loadingFile">
        <img :src="viewUrl" class="w-full h-full" v-if="isImg" />
        <iframe v-else :src="viewUrl" class="w-full h-full"></iframe>
      </div>
    </el-dialog>
    <!-- 上传文件弹窗 -->
    <el-dialog
      v-if="uploadAttachmentsVisible"
      :close-on-click-modal="false"
      :visible.sync="uploadAttachmentsVisible"
      :title="$t('uploadFiles')"
      append-to-body
      width="540px"
      v-dialogDrag
    >
      <UploadFiles
        :initFiles="initFiles"
        @uploadConfirm="uploadAttachmentsConfirm"
        @removeFile="removeFile"
        :uploadLoading="uploadAttachmentsLoading"
        :multiple="true"
        ref="uploadFile"
      ></UploadFiles>
    </el-dialog>
  </div>
</template>

<script>
import ReferenceDataService from '@/services/ReferenceDataService'
import assetService from '@/services/assetService'
import documentManagementService from '@/services/documentManagement'
import UploadFiles from './uploadFiles'
import refrenceAttributeSearch from './refrenceAttributeSearch'

export default {
  name: 'attributeTable',
  props: {
    attributeTableProps: {
      type: Object,
      default: () => {},
    },
  },
  components: { refrenceAttributeSearch, UploadFiles },
  data() {
    return {
      attributeList: [],
      classGroupList: [],
      tableLoading: false,
      activeTabName: '0',
      tabPaneList: [],
      attributeData: {},
      attributeValue: {},
      classGroupValue: {},
      totalNullable: [],
      detail: {},
      currentIndex: null,
      referenceInfo: {},
      isShowRefrenceAttribute: false,
      referenceDataObj: { 1: [] },
      currentEnv: Wiz.GetModuleConfig('legacy-resource').currentEnv,
      browseItem: null, // 浏览文件
      uploadFileTitle: '上传',
      isFullScreen: false,
      uploadFileVisible: false,
      uploadLoading: false,
      file: '', // 上传文件
      fileExt: ['pptx', 'ppt', 'xlsx', 'xls', 'doc', 'docx', 'txt'], // 转pdf的文件格式
      loadingFile: false,
      isImg: false, // 是否图片
      viewUrl: '',
      currentCode: null,
      currentRow: {},
      uploadId: '', // 上传id
      selectedId: '',
      extendDataList: [],
      uploadAttachmentsVisible: false,
      initFiles: [],
      uploadAttachmentsLoading: false,
      currentAttachments: [], // 当前上传的所有附件
    }
  },
  watch: {
    totalNullable: {
      deep: true,
      immediate: true,
      handler(val) {
        this.$emit('updateNullable', val)
      },
    },
    'attributeTableProps.classId': {
      immediate: true,
      async handler(val) {
        if (val || this.attributeTableProps.type !== 'add') {
          this.getClassList()
          this.getTagsList()
        } else {
          // 新增没类别
          await this.getTagsList()
          if (this.attributeTableProps.rowData) {
            this.getTableValue(this.attributeTableProps.rowData, this.attributeList)
          }
        }
      },
    },
    attributeList: {
      deep: true,
      immediate: true,
      handler(val) {
        _.assign(this.attributeValue, this.comboParams(val))
        this.$emit('attributeValue', {
          attributeValue: this.attributeValue,
          attributeList: this.attributeList,
        })
      },
    },
    classGroupList: {
      deep: true,
      immediate: true,
      handler(val) {
        _.assign(this.classGroupValue, this.comboParams(val))
        this.$emit('classGroupValue', {
          classGroupValue: this.classGroupValue,
          classGroupList: this.classGroupList,
        })
      },
    },
    'attributeTableProps.tableDetailData': {
      immediate: true,
      deep: true,
      async handler(val) {
        if (val && Object.keys(val).length > 0) {
          await this.getClassList()
          this.reverseData(val, this.attributeList)
          this.reverseData(val, this.classGroupList)
          this.attributeList = this.attributeList.map((item) => {
            if (this.attributeTableProps.type === 'add') {
              // 新增时版本必填
              if (item.code === 'Revision') {
                item.disabled = false
                item.isNullable = true
              }
            } else if (this.attributeTableProps.type === 'edit') {
              // 编辑状态版本不可编辑
              if (item.code === 'Revision') {
                item.disabled = true
                item.isNullable = false
              }
            } else if (this.attributeTableProps.type === 'upgrade') {
              // 升版只能编辑名称和版本
              if (item.code === 'Name' || item.code === 'Revision') {
                item.disabled = false
                item.isNullable = true
              } else {
                item.disabled = true
              }
            }
            return item
          })
        }
      },
    },
    currentAttachments: {
      immediate: true,
      deep: true,
      handler(val) {
        // 上传附件数据处理
        if (val) {
          this.classGroupList.forEach((item) => {
            if (item.id === this.currentRow.id) {
              item.files = val || []
              item.value = val
                .map((it) => {
                  return it.documentFileId
                })
                .join(',')
            }
          })
        }
      },
    },
  },
  created() {},
  methods: {
    // 获取焦点
    focus(row) {
      // valueType=5是enum类型，valueType =7是枚举-多选类型(参考数据)
      if (_.includes([5, 7], row.valueType) && row.referenceDataClassId && !row.referenceDataList) {
        this.getReferenceData(row)
      } else if (row.isExtend) {
        this.getExtensionList(row)
      }
    },
    // 获取参考数据
    async getReferenceData(row) {
      const idList = Object.keys(this.referenceDataObj)
      if (!_.includes(idList, row.referenceDataClassId)) {
        const params = {
          SkipCount: 0,
          MaxResultCount: 999,
          cateId: row.referenceDataClassId,
        }
        const res = await ReferenceDataService.getCategoryItem(params)
        if (res && res.code === 0 && res.data) {
          this.$set(row, 'referenceDataList', res.data)
          this.referenceDataObj[row.referenceDataClassId] = res.data
        }
      } else {
        this.$set(row, 'referenceDataList', this.referenceDataObj[row.referenceDataClassId])
      }
    },
    clearReference(index) {
      if (this.attributeTableProps.activeTab === '1') {
        this.attributeList[index].value = null
        this.attributeList[index].displayReferenceAttributeCode = null
      } else {
        this.classGroupList[index].value = null
        this.classGroupList[index].displayReferenceAttributeCode = null
      }
    },
    // 上传文件没有类别id，详情从列表传值
    getTableValue(val, tableList) {
      Object.keys(val).forEach((item) => {
        tableList.forEach((el) => {
          if (`${el.tableName}.${el.columnName}` === item) {
            el.value = val[item]
          }
          // isPrimary主键不能修改
          if (el.isPrimary && (el.value !== '' || el.value !== null)) {
            el.disabled = true
          }
        })
      })
    },
    // 详情解析数据
    reverseData(val, tableList) {
      if (!val) return
      Object.keys(val).forEach((item) => {
        tableList.forEach((el) => {
          if (`${el.tableName}.${el.columnName}` === item) {
            el.value = val[item]
          }
          // isPrimary主键不能修改
          if (
            el.isPrimary &&
            (el.value !== '' || el.value !== null) &&
            this.attributeTableProps.type !== 'upgrade'
          ) {
            el.disabled = true
            this.$emit('primaryData', el)
          }
        })
      })
      tableList.forEach(async (el) => {
        // 引用属性
        if (el.referenceClassAttributeId && el.value) {
          this.referenceInfo = el.referenceInfo
          el.displayReferenceAttributeCode = el.value
          el.value = await this.getDisplayReferenceAttributeCode(el)
        }
        // valueType=5是enum类型，valueType =7是枚举-多选类型(参考数据)
        if (_.includes([5, 7], el.valueType) && el.referenceDataClassId && !el.referenceDataList) {
          this.getReferenceData(el)
        }
        if (el.isExtend) {
          this.getExtensionList(el)
        }
        // valueType = 7为枚举-多选
        if (el.valueType === 7 && el.value) {
          el.value = el.value.split(',')
        }
        // 扩展属性多选特殊处理
        if (el.isExtend) {
          this.$set(el, 'tempValue', (el.value && el.value.split(',')) || [])
        }
        // 附件
        if (el.valueType === 13) {
          el.files = _.cloneDeep(el.value) || []
          el.value = el.value
            .map((it) => {
              return it.documentFileId
            })
            .join(',')
        }
      })
    },
    // 保存时组装数据
    comboParams(list) {
      let key = null
      const obj = {}
      list.forEach((item) => {
        key = `${item.tableName}.${item.columnName}`
        obj[key] = item.value
      })
      return obj
    },
    // 获取位号列表
    async getTagsList() {
      const parameter = {
        cateCode: null,
        classId: this.attributeTableProps.classId,
        standardId: this.attributeTableProps.standardId,
      }
      if (this.attributeTableProps.tabs[0].name === '位号') {
        parameter.cateCode = 'Tag'
      } else if (this.attributeTableProps.tabs[0].name === '文档') {
        parameter.cateCode = 'Document'
      } else {
        parameter.cateCode = null
      }
      const res = await documentManagementService.getTagsList(parameter)
      if (res && res.code === 0) {
        this.attributeList = _.map(res.data, (item) => {
          if (item.referenceClassAttributeId) {
            item.displayReferenceAttributeCode = '' // 添加displayReferenceAttributeCode，是显示引用的值，value是引用属性的值
          }
          if (this.attributeTableProps.type === 'add') {
            // 新增时版本必填
            if (item.code === 'Revision') {
              item.disabled = false
              item.isNullable = true
            }
          }
          return item
        })
        // isNullable不能为空的必填项组装在一起
        _.map(res.data, (el) => {
          if (el.isNullable) {
            this.totalNullable.push(`${el.tableName}.${el.columnName}`)
          }
        })
      }
    },
    // 获取实体类别分组列表
    async getClassList() {
      const res = await documentManagementService.getDynamicList({
        classId: this.attributeTableProps.classId,
      })
      if (res && res.code === 0) {
        this.tabPaneList = Object.keys(res.data)
        this.activeTabName = '0'
        this.classGroupList = res.data[this.tabPaneList[0]]
        this.addClassGroupName()
        this.attributeData = res.data
        Object.values(res.data).forEach((item) => {
          // isNullable不能为空的必填项组装在一起
          _.map(item, (el) => {
            if (el.isNullable) {
              this.totalNullable.push(`${el.tableName}.${el.columnName}`)
            }
          })
        })
        // 新增时显示默认值
        if (this.attributeTableProps.type === 'add') {
          this.classGroupList = this.classGroupList.map((item) => {
            if (item.defaultValue) {
              this.$set(item, 'value', item.defaultValue)
            }
            return item
          })
        }
        // 升版不可编辑
        if (this.attributeTableProps.type === 'upgrade') {
          this.classGroupList = this.classGroupList.map((item) => {
            item.disabled = true
            return item
          })
        }
      }
    },
    // 添加name用来显示引用的值
    addClassGroupName() {
      this.classGroupList = _.map(this.classGroupList, (item) => {
        if (item.referenceClassAttributeId) {
          item.displayReferenceAttributeCode = '' // 添加displayReferenceAttributeCode，是显示引用的值，value是引用属性的值
        }
        return item
      })
    },
    // tab切换
    activeTabChange(val) {
      this.classGroupList = this.attributeData[Object.keys(this.attributeData)[val.name]]
      this.addClassGroupName()
      this.reverseData(this.attributeTableProps.tableDetailData, this.classGroupList)
    },
    // 根据显示引用属性的code，查找引用属性的code
    async getDisplayReferenceAttributeCode(row) {
      const params = {
        DataId: this.attributeTableProps.tableDetailData.id,
        AttributeId: row.id,
        ClassId: row.classId,
        StandardId: this.attributeTableProps.standardId,
        exactValue: row.value, // 精确查找
        SkipCount: 0,
        MaxResultCount: 99,
      }
      const res = await documentManagementService.getReferenceColumnData(params)
      if (res && res.code === 0 && res.data) {
        return res.data[0][this.referenceInfo.referenceAttributeCode]
      }
      return null
    },
    // 下拉数据
    async focusMul(row) {
      this.disabledBtn = true
      const params = {
        dataId: this.attributeTableProps.tableDetailData.id,
        attributeId: row.id,
        classId: row.classId,
        standardId: this.attributeTableProps.standardId,
      }
      const res = await documentManagementService.getReferenceColumnData(params)
      if (res && res.code === 0 && res.data) {
        this.disabledBtn = false
        row.transitList = res.data
        this.$forceUpdate()
      }
    },
    searchReference(row, index) {
      this.currentIndex = index
      this.detail.dataId = this.attributeTableProps.tableDetailData?.id
      this.detail.attributeId = row.id
      this.detail.classId = row.classId
      this.referenceInfo = row.referenceInfo
      this.isShowRefrenceAttribute = true
    },
    selectReferenceClassAttributeId(val) {
      this.isShowRefrenceAttribute = false
      if (this.attributeTableProps.activeTab === '1') {
        this.attributeList[this.currentIndex].value = val[this.referenceInfo.referenceAttributeCode]
        this.attributeList[this.currentIndex].displayReferenceAttributeCode =
          val[this.referenceInfo.displayReferenceAttributeCode]
      } else {
        this.classGroupList[this.currentIndex].value =
          val[this.referenceInfo.referenceAttributeCode]
        this.classGroupList[this.currentIndex].displayReferenceAttributeCode =
          val[this.referenceInfo.displayReferenceAttributeCode]
      }
    },
    async change(row) {
      // console.log(row, 'row')
      if (row.isExtend && row.tempValue) {
        row.value = row.tempValue.join(',') || ''
      }
      // ruleExpression不存在不允许调接口
      // const ruleList = _.filter(this.attributeList, (item) => {
      //   return item.ruleExpression !== '' && item.ruleExpression !== null
      // })
      // if (ruleList.length === 0) {
      //   return
      // }
      // const parameter = {
      //   ClassId: this.classId,
      //   Items: [],
      // }
      // // 过滤数组
      // const arr = _.cloneDeep(this.attributeList)
      // const arr1 = arr.filter((item) => {
      //   return (
      //     item.ruleExpression !== '' &&
      //     item.ruleExpression !== null &&
      //     item.value !== '' &&
      //     item.value !== null
      //   )
      // })
      // // 组合参数
      // _.forEach(arr1, (item) => {
      //   const obj = {}
      //   obj.classAttributeCode = item.code
      //   obj.value = item.value
      //   parameter.Items.push(obj)
      // })
      // const res = await stdClassDataService.getcode(parameter)
      // if (res && res.code === 0 && res.data) {
      //   // 反显代码
      //   this.attributeList.forEach((item, index) => {
      //     res.data.forEach((it) => {
      //       if (item.code === it.item) {
      //         this.attributeList[index].value = it.code
      //       }
      //     })
      //   })
      // }
    },
    operateColumn(column) {
      // 附加在文本
      const isAddedInText = _.find(column.opereateList, ['presentationTypeStr', '附加在文本'])
      if (_.isNil(isAddedInText)) {
        return
      }
      if (isAddedInText.businessOperationName === '打开文件') {
        this.viewFile(column)
        return
      }
      if (isAddedInText.businessOperationName === '下载文件') {
        const index = column.value.lastIndexOf('.')
        const fileName = column.value.slice(0, index)
        window.location.href = `${this.currentEnv.VUE_APP_UPLOAD_SERVER}/api/Common/file?downloadType=1&target=${fileName}&type=0`
      }
    },
    async viewFile(row, type, column) {
      if (type === 'isView') {
        this.selectedId = row.id
        let stdClassAttributeId = null
        _.map(this.attrList, (item) => {
          if (item.columnName === column) stdClassAttributeId = item.stdClassAttributeId
        })
        await this.getFileId(stdClassAttributeId)
      } else {
        await this.getFileId(row.stdClassAttributeId)
      }
      if (this.browseItem !== null) {
        $('#viewDialog .el-dialog').height(600)
        this.uploadFileTitle = this.$t('view')
        this.uploadFileVisible = true
        this.loadingFile = true
        // 通过fileId拿到返回的文件流
        if (_.includes(this.imgExt, this.browseItem.fileType.split('.')[1])) {
          // png
          this.isImg = true
          const resData = await assetService.browsePNG({ fileId: this.browseItem.fileId })
          if (resData) {
            const blob = new Blob([resData], { type: 'image/jpeg' })
            const url = window.URL.createObjectURL(blob)
            this.viewUrl = url
            this.loadingFile = false
          }
        } else {
          // pdf
          this.isImg = false
          const resData = await assetService.browsePDF({ fileId: this.browseItem.fileId })
          if (resData) {
            const blob = new Blob([resData], { type: 'application/pdf' })
            const url = window.URL.createObjectURL(blob)
            this.viewUrl = url
            this.loadingFile = false
          }
        }
      } else {
        this.$message.warning('没有上传文件')
      }
    },
    showUploadBtn(column) {
      // 上传按钮
      const uploadOperateAttr = _.find(column.opereateList, ['businessOperationName', '上传文件'])
      if (_.isNil(uploadOperateAttr)) {
        return false
      }
      if (uploadOperateAttr.presentationTypeStr === '列按钮') {
        return true
      }
      return false
    },
    showViewBtn(column) {
      // 查看按钮
      const uploadOperateAttr = _.find(column.opereateList, ['businessOperationName', '打开文件'])
      if (_.isNil(uploadOperateAttr)) {
        return false
      }
      if (uploadOperateAttr.presentationTypeStr === '列按钮') {
        return true
      }
      return false
    },
    showDownloadBtn(column) {
      // 下载按钮
      const uploadOperateAttr = _.find(column.opereateList, ['businessOperationName', '下载文件'])
      if (_.isNil(uploadOperateAttr)) {
        return false
      }
      if (uploadOperateAttr.presentationTypeStr === '列按钮') {
        return true
      }
      return false
    },
    showDeleteBtn(column) {
      // 删除按钮
      const uploadOperateAttr = _.find(column.opereateList, ['businessOperationName', '删除文件'])
      if (_.isNil(uploadOperateAttr)) {
        return false
      }
      if (uploadOperateAttr.presentationTypeStr === '列按钮') {
        return true
      }
      return false
    },
    uploadFiles(row, code) {
      $('#viewDialog .el-dialog').height(344)
      $('#fileView').height(215)
      this.currentCode = code
      this.currentRow = row
      this.uploadFileTitle = this.$t('upload')
      this.uploadFileVisible = true
      this.uploadId = row.stdClassAttributeId
    },
    deleteFile(row, code) {
      this.currentCode = code
      this.currentRow = row
      if (!row.value) {
        this.$message.warning('未上传文件')
        return
      }
      this.$confirm(this.$t('confirmToDeleteForever'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
      }).then(async () => {
        const res = await assetService.deleteFile({ ownerId: this.selectedId })
        if (res && res.code === 0) {
          this.$message.success(this.$t('successfullyDeleted'))
          this.getFileId(row.stdClassAttributeId)
        }
      })
    },
    async getFileId(id) {
      // 1.先通过当前记录的id拿到fileId
      const res = await assetService.getFileId({ ownerId: this.selectedId, stepId: id })
      if (res.length > 0) {
        this.browseItem = res[res.length - 1]
      } else {
        this.browseItem = null
        // this.$set(this.currentRow, 'value', '')
        _.map(this.attributeList, (item, index) => {
          if (item.code === this.currentCode) {
            this.$set(this.attributeList[index], 'value', '')
          }
        })
      }
    },
    // 全屏
    fullScreen() {
      this.isFullScreen = true
      this.launchFullscreen(document.getElementById('viewDialog'))
    },
    // 判断各种浏览器，找到正确的方法
    launchFullscreen(element) {
      if (element.requestFullscreen) {
        element.requestFullscreen()
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen()
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen()
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen()
      }
      $('#viewDialog .el-dialog')
        .width(window.screen.width)
        .height(window.screen.height)
      $('#fileView').height(window.screen.height - 100)
    },
    exitFullScreen() {
      this.isFullScreen = false
      this.exitFullscreen()
      if (this.uploadFileTitle === this.$t('upload')) {
        $('#viewDialog .el-dialog')
          .width(530)
          .height(344)
        $('#fileView').height(215)
        return
      }
      $('#viewDialog .el-dialog')
        .width(1200)
        .height(600)
      $('#fileView').height(515)
    },
    // 退出全屏
    exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen()
      }
    },
    getFileContent(file) {
      this.file = file
    },
    // 上传操作
    async uploadExcel() {
      if (this.type === 'add') {
        this.addUpload()
      } else {
        this.editUpload()
      }
    },
    // 新增的时候上传图片，先保存数据，再上传图片
    addUpload() {
      this.$set(this.currentRow, 'value', this.file.name)
      _.map(this.attributeList, (item, index) => {
        if (item.code === this.currentCode) {
          this.$set(this.attributeList, index, this.currentRow)
        }
      })
      this.$message.success('上传成功')
      this.hasUpload = true
      this.uploadFileVisible = false
    },
    // 编辑的时候上传图片
    async editUpload() {
      // 上传文件前要先把之前上传的先给删掉
      this.uploadLoading = true
      if (this.browseItem !== null) {
        const delRes = await assetService.deleteFile({ ownerId: this.selectedId })
        if (delRes) console.log('删除成功')
      }
      const formData = new FormData()
      _.forIn({ file: this.file }, (value, key) => {
        formData.append(key, value)
      })
      const fileType = _.split(this.file.name, '.')[1]
      if (_.includes(this.fileExt, fileType)) {
        formData.append('Type', 1) // Type为1需要转成pdf
      } else {
        formData.append('Type', 0) // Type为0不需要转
      }
      formData.append('Id', this.selectedId)
      formData.append('StepId', this.uploadId) // 步骤或字段属性id
      const res = await assetService.uploadFile({
        reqData: formData,
      })
      this.uploadLoading = false
      if (res) {
        if (this.type !== 'add') {
          this.$message.success('上传成功')
        }
        if (_.includes([...this.imgExt, 'pdf'], res[res.length - 1].fileType.split('.')[1])) {
          this.browseItem = res[res.length - 1]
        } else {
          this.browseItem = res[res.length - 1]
        }
        this.$set(this.currentRow, 'value', this.browseItem.name)
        _.map(this.attributeList, (item, index) => {
          if (item.code === this.currentCode) {
            this.$set(this.attributeList, index, this.currentRow)
          }
        })
        this.uploadFileVisible = false
      }
    },
    downloadFile(column) {
      // 下载文件
      if (!column.value) {
        this.$message.warning('未上传文件')
        return
      }
      const index = column.value.lastIndexOf('.')
      const fileName = column.value.slice(0, index)
      window.location.href = `${this.currentEnv.VUE_APP_UPLOAD_SERVER}/api/Common/file?downloadType=1&target=${fileName}&type=0`
    },
    // 获取扩展属性下拉数据
    async getExtensionList(row) {
      const res = await documentManagementService.getExtendClassList({
        classId: this.attributeTableProps.classId,
      })
      if (res && res.code === 0) {
        this.$set(row, 'extendList', res.data)
        res.data.forEach((item) => {
          row.tempValue.forEach((it) => {
            if (item.extendClassCode === it) {
              this.extendDataList.push(item)
            }
          })
        })
        this.$emit('extendTableValue', this.extendDataList)
      }
    },
    // 上传附件
    uploadAttachments(row) {
      this.currentRow = row
      this.uploadAttachmentsVisible = true
      this.initFiles = row.files || []
      this.currentAttachments = row.files || []
    },
    // 点击确定按钮
    async uploadAttachmentsConfirm(fileData) {
      const formData = new FormData()
      const files = _.map(_.cloneDeep(fileData), (i) => {
        return i.raw
      })
      files.forEach((item) => {
        formData.append('formFiles', item)
      })
      formData.append('standardId', this.attributeTableProps.standardId)
      this.uploadAttachmentsLoading = true
      const res = await documentManagementService.uploadAttachments(formData)
      this.uploadAttachmentsLoading = false
      if (res && res.code === 0) {
        this.$message.success('上传成功')
        this.uploadAttachmentsVisible = false
        this.currentAttachments = [...this.currentAttachments, ...res.data]
      }
    },
    // 移除文件
    removeFile(val) {
      this.currentAttachments = this.currentAttachments.filter((item) => {
        return item.documentFileId !== val.documentFileId
      })
    },
  },
}
</script>

<style lang="scss" scoped>

.can-not-input {
  ::v-deep input {
    pointer-events: none;
  }
}
.append_unit {
  position: relative;
  &::after {
    content: attr(data-unit);
    position: absolute;
    top: 1px;
    right: 0;
    padding: 0 20px;
    color: #515a6e;
    background: #ebeef5;
    border: 1px solid #dcdee2;
    border-radius: 4px;
    height: 36px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}
.el-input-number.is-without-controls .el-input__inner {
  text-align: left !important;
}

</style>
